<app-block-ui [loading]="loading">
  <ng-container>
    <p>Učitavanje</p>
  </ng-container>
</app-block-ui>

<form [formGroup]="form" (ngSubmit)="onSubmit()" #pTypeForm>
  <div class="main-card">
    <div class="card-header">
      <a class="main-btn back-btn" [routerLink]="['./../../']"
        ><i class="pi pi-angle-left m-0"></i
      ></a>
      <button
        class="main-btn"
        type="submit"
        [ngClass]="{ disabled: !form.valid }"
        [disabled]="!form.valid"
      >
        Snimi <i class="pi pi-save"></i>
      </button>
    </div>
    <h3 class="card-title">Dodaj partnera</h3>
    <div class="card-body">
      <div class="grid">
        <div class="col-4">
          <div class="field">
            <label>Šifra partnera</label>
            <input type="text" formControlName="code" pInputText />
          </div>

          <div class="field">
            <label>Kompanija</label>
            <input type="text" formControlName="company" pInputText />
          </div>

          <div class="field">
            <label>Kontakt osoba</label>
            <input type="text" formControlName="contact" pInputText />
          </div>

          <div class="field">
            <label>Adresa</label>
            <input type="text" formControlName="address" pInputText />
          </div>
        </div>
        <div class="col-4">
          <div class="field">
            <label>Email</label>
            <input type="text" formControlName="email" pInputText />
          </div>

          <div class="field">
            <label>Telefon</label>
            <input type="text" formControlName="phone" pInputText />
          </div>

          <div class="field">
            <label>Napomena</label>
            <textarea
              type="text"
              rows="9"
              formControlName="note"
              pInputText
            ></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
